export class Template {
  templateId: number;
  clientId: number;
  templateName: string;
  dltTemplateId: string;
  templateMsg: string;
  templateIsActive: 'YES' | 'NO' = 'YES';

  constructor(init?: Partial<Template>) {
    Object.assign(this, init);
  }
}